enum UiScreenType {
  Desktop = 'Desktop',
  Tablet = 'Tablet',
  MobileLandscape = 'MobileLandscape',
  Mobile = 'Mobile',
}

const UiModeBreakpoints = {
  mobile: 360,
  mobileLandscape: 500,
  tablet: 768,
  desktop: 1280,
}

export { UiModeBreakpoints }
export default UiScreenType
